import { render, staticRenderFns } from "./Complete.vue?vue&type=template&id=68960524&scoped=true&"
import script from "./Complete.vue?vue&type=script&lang=js&"
export * from "./Complete.vue?vue&type=script&lang=js&"
import style0 from "./Complete.vue?vue&type=style&index=0&id=68960524&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68960524",
  null
  
)

export default component.exports